type EditorApply = (html: string) => void

let apply: EditorApply | null = null

export const registerEditorApply = (fn: EditorApply) => {
	apply = fn
}

export const applyEditorContent = (html: string) => {
	if (apply !== null) {
		apply(html)
	}
}
